import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../state/state.tsx";
import { closeModal } from "../../../state/ModalSlice/ModalSlice.ts";
import QRCode from "react-qr-code";
import CloseIcon from "@mui/icons-material/Close";
import html2canvas from "html2canvas";
import { Download } from "@mui/icons-material";
import { format } from "date-fns";
import {
  setFieldsForOfferQRCode,
  setFieldsForEventQRCode,
} from "../../../state/ArbitrarySlice/ArbitratySlice.ts";

export default function QREventsandOfferModal() {
  const Dispatch = useAppDispatch();
  const open = useAppSelector(
    (state: RootState) => state.ModalSlice.QREventsandOfferModalOpen
  );
  const eventQRCode = useAppSelector(
    (state: RootState) => state.ArbitrarySlice.ForEventQRCode
  );
  const offerQRCode = useAppSelector(
    (state: RootState) => state.ArbitrarySlice.ForOfferQRCode
  );
  const QRCodeSource = useAppSelector(
    (state: RootState) => state.ArbitrarySlice.ForQRCodeSource
  );

  function handleClose() {
    Dispatch(closeModal("QREventsandOfferModalOpen"));
    // Clear the QR code data when closing the modal
    try {
      const offerData = {
        BuzzName: "",
        StartDate: { seconds: 0, nanoseconds: 0 },
        EndDate: { seconds: 0, nanoseconds: 0 },
        address: "",
        offerLink: "",
      };
      const eventData = {
        eName: "",
        eStartTime: { seconds: 0, nanoseconds: 0 },
        address: "",
        eventLink: "",
      };

    
      Dispatch(setFieldsForOfferQRCode(offerData));

     
      Dispatch(setFieldsForEventQRCode(eventData));
    } catch (error) {
      console.error("Error dispatching QR code data:", error);
    }
  }

  // QR Code

  const handleCaptureClick = async () => {
    const QRCodeElement = document.querySelector<HTMLElement>("#QRCode-Page");
    if (!QRCodeElement) return;

    const canvas = await html2canvas(QRCodeElement, {
      useCORS: true, // To handle cross-origin images
      backgroundColor: "#86B6F6", // Set a background color
      scale: 2, // Increase resolution of the canvas
      scrollX: 0, // Prevent scroll-related misalignment
      scrollY: 0,
    });

    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png", 1.0); // Ensure high-quality PNG
    link.download = "QRCode.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog
      sx={{
        padding: 0,
        "& .MuiPaper-root": {
          borderRadius: "10px",
        },
      }}
      maxWidth="md"
      open={open}
      PaperProps={{
        component: "div",
      }}
    >
      <DialogContent
        sx={{
          paddingX: "40px",
          paddingY: "30px",
          maxHeight: "100vh", // Set a maximum height for the modal
          background: "linear-gradient(to bottom, #86B6F6, #A0C4FF)", // Updated to gradient background
          maxWidth: "40vw",
          overflow: "hidden",
          margin: "0 auto",
        }}
        className={"bg-blue"}
      >
        <div className={"absolute right-4 top-4"}>
          <button
            onClick={handleClose}
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            <CloseIcon />
          </button>
        </div>

        <div id={"QRCode-Page"}>
         <div
            className={
              "header pb-[20px] min-w-[50px] min-h-[50px] flex flex-col"
            }
              >
            <p
              className={
                "text-cf_heading font-bold text-center text-5xl mt-4 mb-2 pl-2 pr-2"
              }
              style={{ fontFamily: "Pacifico, cursive" }}
            >
              {eventQRCode.eName || offerQRCode.BuzzName || "Event/Offer Title"}
            </p>
          </div>

          <div className=" ml-3 mr-3 mb-2">
            <div className="flex items-start gap-2">
              <span className="flex items-center justify-center h-6 text-xl">
                 📍
                </span>
              <p className="font-semibold m-0 leading-tight text-base">
              {eventQRCode.address || offerQRCode.address || "Location"}
              </p>
            </div>
          </div>
          <div className=" ml-3 mr-3">
            <div className="flex items-start gap-2">
              <span className="flex items-center justify-center h-5 text-xl">
                🗓️
              </span>
              <span>
                <p className="font-semibold m-0 leading-tight text-base">
                  {QRCodeSource.qrCodeSource === "offer"
                    ? offerQRCode.StartDate && offerQRCode.EndDate
                      ? `Valid from ${format(
                          new Date((offerQRCode.StartDate?.seconds || 0) * 1000),
                          "MMM dd, yyyy"
                        )} to ${format(
                          new Date((offerQRCode.EndDate?.seconds || 0) * 1000),
                          "MMM dd, yyyy"
                        )}`
                      : "Date"
                    : QRCodeSource.qrCodeSource === "event"
                    ? eventQRCode.eStartTime
                      ? format(new Date((eventQRCode.eStartTime?.seconds || 0) * 1000), "MMM dd, yyyy")
                      : "Date"
                    : "Date"}
                </p>
              </span>
            </div>
          </div>

          <div
            className={"pb-2 py-6 flex flex-col items-center w-full"}
            style={{ position: "relative" }}
          >
            <div
              className={
                "bg-#86B6F6 p-4 rounded-xl flex flex-col items-center relative z-10"
              }
            >
              <div className={"p-4 bg-#86B6F6"}>
                <QRCode
                  size={150}
                  style={{
                    height: "auto",
                    width: "150px",
                    clipPath: "circle(90% at 50% 50%)",
                    filter: "blur(0px)",
                    zIndex: 1,
                  }}
                  value={eventQRCode.eventLink || offerQRCode.offerLink || ""}
                  viewBox={`0 0 256 256`}
                  bgColor="transparent"
                />
              </div>
              <div
                className={
                  "font-semibold text-white flex flex-col items-center mt-6"
                }
              >
                <p
                  className={"text-cf_subHeading"}
                  style={{
                    color: "black",
                    fontFamily: "Roboto, sans-serif",
                    fontSize: "1 rem",
                  }}
                >
                  SCAN IT NOW!
                </p>
                <p
                  style={{
                    color: "black",
                    fontFamily: "Roboto, sans-serif",
                    fontSize: "1 rem",
                  }}
                >
                  {eventQRCode.eName
                    ? "Buy your Ticket(s)"
                    : "Redeem your Offer(s)"}
                </p>
              </div>
            </div>
            <div className={"mt-1 mb-3 ml-1 mr-2"}>
              Managed by{" "}
              <span className={"text-cc_brand font-semibold"}>
                <a href="https://www.hosaksham.com/">
                  EagleX SAS Makers Private Limited
                </a>
              </span>
            </div>
          </div>
        </div>
        <div className={"flex gap-2 pt-1"}>
          <button
            onClick={(e) => {
              e.preventDefault();
              handleCaptureClick(); // Capture the entire modal content
            }}
            className={
              "w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center gap-2"
            }
          >
            <Download /> Download QR Code
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}